import { nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue';

export function useScrollSpy(idsRef, options = {}) {
  const activeId = ref(
    Array.isArray(idsRef?.value) ? idsRef.value[0] : idsRef?.[0] ?? null
  );
  let observer = null;

  const rootMargin = options.rootMargin ?? '-10% 0px -80% 0px';
  const threshold = options.threshold ?? [0, 0.1, 0.25, 0.5, 1];

  const getIds = () =>
    Array.isArray(idsRef?.value) ? idsRef.value : Array.isArray(idsRef) ? idsRef : [];

  async function setup(ids) {
    observer?.disconnect?.();
    observer = null;

    if (!Array.isArray(ids) || ids.length === 0) return;
    if (!('IntersectionObserver' in window)) return;

    await nextTick();

    observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => (b.intersectionRatio ?? 0) - (a.intersectionRatio ?? 0));

        if (visible[0]?.target?.id) activeId.value = visible[0].target.id;
      },
      { root: null, rootMargin, threshold }
    );

    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
  }

  onMounted(() => setup(getIds()));

  watch(
    () => getIds(),
    (ids) => setup(ids),
    { deep: false }
  );

  onBeforeUnmount(() => {
    observer?.disconnect?.();
    observer = null;
  });

  return { activeId };
}
